module.exports = __webpack_public_path__ + "static/media/icon_mute.c104e9a9.svg";